import request from "../../utils/request";

export function doGetAllCompanies(params) {
  return request("/companies", {
    method: "GET",
    params,
  });
}

export function doCreateCompany(params) {
  return request("/companies", {
    method: "POST",
    data: params,
  });
}

export function doUpdateCompany(params) {
  return request(`/companies/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doGetAllPartnerCompanies(params) {
  return request("/partner-companies", {
    method: "GET",
    params,
  });
}

export function doCreatePartnerCompany(params) {
  return request("/partner-companies", {
    method: "POST",
    data: params,
  });
}

export function doUpdatePartnerCompany(params) {
  return request(`/partner-companies/${params.id}`, {
    method: "PUT",
    data: params,
  });
}
